import { defineStore } from 'pinia';

const state: any = {
	global: {
		defaults: {
			country: 'AT',
		},
	},
};

export const useSettingsStore = defineStore('settings', {
	state: () => state,
});
